export const MY_DOCUMENTS_FOR_SIGNING_PATH = "/my-documents-for-signing";
